export default __webpack_public_path__ + "static/media/1815.2d73e270.png";